import React from "react"
import "./banner.css"

export class BannerVideo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isMobileView: false,
    }
  }

  componentDidMount = () => {
    const screenWidth = window.innerWidth
    const isMobileView = screenWidth <= 767
    this.setState(
      (state) => ({
        isMobileView,
      }),
      () => {
        setTimeout(() => {
          this.setHomepageBannerTitleMobileView()
        }, 500)
      }
    )
  }

  setHomepageBannerTitleMobileView = () => {
    const homepageBannerTitles = document.getElementsByClassName(
      "homepage-banner-title"
    )
    if (homepageBannerTitles && homepageBannerTitles.length > 0) {
      const homepageBannerTitle = homepageBannerTitles[0]
      if (homepageBannerTitle) {
        const backgroundVideo = document.getElementById("BackgroundVideo")
        if (backgroundVideo) {
          const marginBottom =
            backgroundVideo.clientHeight -
            (homepageBannerTitle.clientHeight + 30)
          homepageBannerTitle.style.marginBottom = `${marginBottom}px`
        }
      }
    }
  }

  renderVideoElement = () => {
    const videoURL = this.props.videoURL
    const videoMP4Src = <source src={`${videoURL}`} type="video/mp4" />
    let element = <></>
    if (this.state.isMobileView) {
      element = (
        <video
          id="BackgroundVideo"
          width={"170%"}
          autoplay="autoplay"
          muted="muted"
          loop="loop"
          playsinline="playsinline"
          // controls
        >
          {videoMP4Src}
        </video>
      )
    } else {
      element = (
        <video
          height={"100%"}
          autoplay="autoplay"
          muted="muted"
          loop="loop"
          playsinline="playsinline"
          // controls
        >
          {videoMP4Src}
        </video>
      )
    }
    return element
  }

  render() {
    const html = (
      <>
        <div
          className="banner-container banner-video-container"
          style={{
            height: `${this.props.imgHeight}px`,
          }}
        >
          {this.renderVideoElement()}
          {this.props.content}
        </div>
        <div className="banner-bottom-line">
          <div></div>
        </div>
      </>
    )
    return html
  }
}
